module.exports = __webpack_public_path__ + "img/pdf-label-en.45d8d480.jpg";